import { MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { getBusinessUnit } from 'wisestep-api';

import BusinessUnitForm from '../features/clientsSettings/components/BusinessUnitForm';
import IBusinessUnit from '../features/ourEntity/types/IBusinessUnit';
import { useDialog } from '../hooks/useDialog';

import { SelectWCreate } from './SelectWCreate';

export const SelectBusinessUnit = ({ name }) => {
  const form = useFormContext();
  const [openDialog, closeDialog] = useDialog();
  const [businessUnits, setBusinessUnits] = useState<IBusinessUnit[]>([]);

  const fetchBusinessUnits = async () => {
    const response = await getBusinessUnit();
    setBusinessUnits(response.data);
  };

  useEffect(() => {
    fetchBusinessUnits();
  }, []);

  return (
    <SelectWCreate
      renderValue={(value: IBusinessUnit) => value?.name ?? ''}
      onCreate={() => {
        form.setValue(name, null);
        openDialog({
          children: (
            <BusinessUnitForm
              onClose={() => closeDialog()}
              onSave={async (bu) => {
                await fetchBusinessUnits();
                form.setValue(name, bu);
                closeDialog();
              }}
            />
          ),
        });
      }}
      name={name}
      label={'Business Unit'}
    >
      {businessUnits.map((option) => (
        <MenuItem key={option.id} value={option as any}>
          {option.name}
        </MenuItem>
      ))}
    </SelectWCreate>
  );
};
